import { cva } from 'class-variance-authority';

import { cn } from '@heidi/utils';

import { colorClasses, sizeClasses } from './framed-icon.styles';

/**
 * DS-1202 experimental FramedIcon recipe: semantic states consume the
 * reworked `semantic-background-*` / `semantic-text-*` tier. Neutral/tier
 * states and the entity `color` map are unchanged. Behind
 * `release-experimental-design-system-forms`.
 */
export const stateClassesExperimental = {
  neutral: cn('bg-surface-accent text-text-primary newBrandDark:bg-surface-elevated'),
  error: cn('bg-semantic-background-destructive text-semantic-text-destructive'),
  warning: cn('bg-semantic-background-warning text-semantic-text-warning'),
  success: cn('bg-semantic-background-success text-semantic-text-success'),
  pro: cn('bg-tier-pro-muted text-tier-pro-text'),
  practice: cn('bg-tier-practice-muted text-tier-practice-text'),
} as const;

export const framedIconVariantsExperimental = cva(
  cn('inline-flex shrink-0 items-center justify-center'),
  {
    variants: {
      size: sizeClasses,
      state: stateClassesExperimental,
      color: colorClasses,
    },
    defaultVariants: {
      size: 'md',
    },
  }
);
